import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import Highlight from './highlight';

const Highlights = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SplitBlock = ({
  // id,
  columnWidth,
  align,
  justify,
  order,
  offset,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    order={order}
    offset={offset}
  >
    <Highlights>
      <Highlight
        title="Financieren"
        text="Informeer bij ons naar passende mogelijkheden"
        link="/diensten/financieren"
        image={<StaticImage src="./coins.jpeg" alt="Coins" />}
      />
      <Highlight
        title="Private & Financial Lease"
        text="Verschillende mogelijkheden en een soepel acceptatiebeleid!"
        link="/leasing"
        image={<StaticImage src="./cars.jpeg" alt="Cars" />}
      />
    </Highlights>
  </Column>
);

export default SplitBlock;
